import {
  getBrowserCookies,
  isLocalStorageAvailable,
  localStore,
} from '@moonpig/web-core-browser-storage'
import { isLoggedIn } from '@moonpig/web-core-auth'
import { z } from 'zod'
import { ScreenViewScreenData } from './types'
import { sanitizeStrings } from './helpers/sanitizeStrings'
import { getCustomerType } from './helpers/getCustomerType'
import { EventObject } from './schemaTypes'
import { userDataSchema } from './schemas/common.schema'

type BasketData = {
  id: string
  size: number
}

type UserData = z.infer<typeof userDataSchema>

type Product = {
  product_brand: string
  product_category?: string
  product_id: string
  product_name?: string
  product_variant?: string
  product_price?: number
  product_quantity: number
  bundle_id?: string
  group_card_id?: string
  design_id?: string
  project_id?: string
  product_orientation?: string
}

type CreateScreenViewProperties = {
  basketData?: BasketData
  screenClass: string
  screenName: string
  screenData: ScreenViewScreenData
  productData?: Product
}

export const createScreenViewEvent = ({
  basketData,
  screenClass,
  screenName,
  screenData,
  productData,
}: CreateScreenViewProperties): EventObject => {
  const userLoggedIn = isLoggedIn(getBrowserCookies())

  const user_data: UserData = {
    customer_id: undefined,
    is_logged_in: userLoggedIn,
    lifetime_order_count: undefined,
    customer_type: undefined,
    login_method: undefined,
    email: undefined,
  }

  if (userLoggedIn && isLocalStorageAvailable()) {
    const userDataInLocalStorage = localStore.getItem('mnpg_ga_user_data')
    const userDataExists = userDataInLocalStorage
      ? JSON.parse(userDataInLocalStorage)
      : undefined
    if (userDataExists) {
      user_data.login_method = 'email'
      user_data.customer_id = userDataExists.id
      user_data.lifetime_order_count = userDataExists.totalCount
      user_data.customer_type = getCustomerType(userDataExists.totalCount)
    }
  }

  const { documentReferrer, documentTitle, documentUrl, renderType } =
    screenData
  return {
    event: 'screen_view',
    basket_data: {
      id: basketData?.id ? basketData.id.toLowerCase() : undefined,
      size: typeof basketData?.size === 'number' ? basketData.size : undefined,
    },
    screen_type: sanitizeStrings(screenClass),
    screen_name: sanitizeStrings(screenName)
      .toLowerCase()
      .substring(0, 100)
      .trim(),
    user_data,
    screen_data: {
      // Web only //
      document_referrer:
        documentReferrer?.substring(0, 500)?.toLowerCase() || undefined,
      document_title: documentTitle?.substring(0, 500)?.toLowerCase(),
      document_url: documentUrl?.substring(0, 500)?.toLowerCase(),
      render_type: renderType,
    },
    product_data: productData,
    // For GTM
    application_data: {
      datalayer_version: 1,
    },
  }
}
